window.BOLD = window.BOLD || {};
window.BOLD.checkout_features_defaults = [
  {
    name: 'Shopify Discount Connector',
    require: true,
    id: '5d8d5c43-dc24-11e7-8128-42010afe0504',
  },
  { name: 'checkout-always-on', require: true },
  {
    name: 'Orderbot Software Inc.',
    require: true,
    id: '74dcadaf-87df-44da-b3a5-4eeca6cb57ba',
  },
  {
    name: 'Staples',
    require: true,
    id: '69cc8403-c2e7-40b0-b5e0-f1d0572821e7',
  },
  {
    name: 'Bold Custom Pricing (Wholesale & Quantity Breaks)',
    require: true,
    id: '4f7ae25f-2922-11e7-9910-42010af00994',
  },
  {
    name: 'MSTS Plugin',
    require: true,
    id: '8f60cf06-f55a-4e60-b2c5-18a33b50da49',
  },
];
